var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("j-headful", { attrs: { title: _vm.$route.meta.title } }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade-slow" } },
        [_vm.showPreload ? _c("j-preload") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _vm.showContent ? _c("j-header") : _vm._e(),
      _vm._v(" "),
      _vm.showContent ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _vm.showContent
        ? _c("j-loading-screen", {
            ref: "loadingScreen",
            attrs: { message: _vm.loading_message }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContent
        ? _c("j-info-screen", {
            ref: "infoScreen",
            attrs: { message: _vm.info_message }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContent
        ? _c("j-problem-screen", {
            ref: "problemScreen",
            attrs: { message: _vm.problem_message, code: _vm.problem_code }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showContent
        ? _c("j-success-screen", {
            ref: "successScreen",
            attrs: { message: _vm.success_message }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("j-toast", { ref: "toastScreen" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39336072", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39336072","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/default.vue
// module id = null
// module chunks = 